exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table>tr>td[data-v-323c84b9]{width:30%;height:30px}.margin-5px[data-v-323c84b9]{margin-right:5px}.width-20px[data-v-323c84b9]{table-layout:fixed;width:20px}.padding-5px[data-v-323c84b9]{padding-right:3%;padding-left:3%}.table-responsive img[data-v-323c84b9]{width:60px}table>tr>td[data-v-323c84b9]:nth-child(odd){font-weight:600}", ""]);

// exports
